<template>
	<div id="loginWrapper">
		<div class="login">
			<form @submit.prevent="login">
				<div class="login_element">
					<label>User</label>
					<input type="text" v-model="username" name="username"
						   placeholder="Benutzername" class="input_field">
				</div>
				<div class="login_element">
					<label>Passwort</label>
					<input type="password" v-model="password" name="password"
						   class="input_field">
				</div>
				<div class="login_element">
					<!-- hack, to get the button aligned right: -->
					<label style="color: black;"></label>
					<input type="submit" value="Login" class="login_btn">
				</div>
			</form>

			<div v-if="error" class="error msg">Login nicht erfolgreich</div>
			<div v-if="success" class="success msg">Login erfolgreich</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import {EventBus} from '@/services/EventBus.js';

	export default {
		name: "Login",
		data() {
			return {
				username: '',
				password: '',
				success: false,
				error: false
			}
		},
		methods: {
			login() {
				console.log('>>> login');

				let username = this.username;
				let password = this.password;

				this.success = false;
				this.error = false;

				axios.post(process.env.VUE_APP_BASE_URL + 'auth/local', {
					"identifier": username,
					"password": password
				})
					.then(res => {
						console.log('>>>> login success');
						localStorage.setItem('token', res.data.jwt);
						this.success = true;
						EventBus.$emit('onLogin');
						setTimeout(function () {
							this.$router.push('/shows');
						}.bind(this), 1000);

					})
					.catch(err => {
						console.log(err);
						this.error = true;
					});
			}
		},
		created() {
			EventBus.$emit('onCurrentShow', '');
		}
	}
</script>

<style scoped>

	#loginWrapper {
		display: flex;
		justify-content: center;
	}

	.login {
		background-color: black;
		padding: 50px;
		width: 400px;
		margin-top: 50px;
	}

	.login_element {
		display: flex;
		justify-content: space-between;
		margin-top: 12px;
	}

	.login_btn {
		font-family: "BrownLLWeb-Regular";
		/*display: flex;
		justify-content: right;*/
		padding: 4px 28px;
		margin-top: 16px;
	}

	label {
		color: white;
		width: 30%;
	}

	.input_field {
		padding: 0px 4px;
		font-family: "BrownLLWeb-Regular";
		color: black;
		width: 70%;
	}

	.msg {
		width: 100%;
		color: white;
		padding: 10px;
		text-align: center;
		margin-top: 20px;
	}

	.success {
		background-color: #00cc00;;
	}

	.error {
		background-color: #b30000;
	}
</style>